import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SubmitAssessmentCommunication(formData) {
  const response = await $.soap({
    body: {
      SubmitAssessmentCommunication: {
        $xmlns: 'http://dla.mil/ems/bpm/common/memo',
        AssessmentId: formData.assessmentId,
        Memo: formData.memo
      }
    }
  });

  cleanUpResponse(response);
  return response;
}